import React, {useCallback, useState} from 'react';
import SectionPopup from './SectionPopup.js';
import PopupSearch from './PopupSearch.js';
import EshopSysadminList from './EshopSysadminList.js';
import usePopupSearch from '../utils/usePopupSearch.js';

// Popup s eshopem konkrétního uživatele (monitoring). Obsah je stejný jako
// v sekci /eshopsysadmin (sdílená komponenta EshopSysadminList), hledání se
// předvyplní jménem uživatele a jde libovolně přepsat.
export default function UserEshopPopup({show, close, user, usrInfo, onNavigate}) {
	const [loading, setLoading] = useState(false);
	const userSearch = `${user?.LASTNAME || ''} ${user?.FIRSTNAME || ''}`.trim();
	const userName = user?.NAME || userSearch;
	const {searchInput, search, onChangeSearch} = usePopupSearch(show, userSearch);

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	return (
		<SectionPopup
			show={show}
			close={close}
			title={`Eshop${userName !== '' ? ` – ${userName}` : ''}`}
			toolbar={<PopupSearch searchValue={searchInput} onChangeSearch={onChangeSearch} placeholder="Vyhledat v eshopu" />}
			loading={loading}
			className="user-eshop-popup"
			onNavigate={onNavigate}
		>
			<div className="eshop-page eshop-page--sysadmin eshop-page--popup">
				<EshopSysadminList usrInfo={usrInfo} searchValue={search} onLoadingChange={handleLoadingChange} />
			</div>
		</SectionPopup>
	);
}
